"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var getSupportQuestions = function (subdomain) {
    return (0, service_1.getService)()
        .get('/support/questions', { params: { subdomain: subdomain } })
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
exports.default = getSupportQuestions;
